export const config_module = {
  base_url: 'https://api.iangels.co',
  context: 'prod',
  domain: 'auth.iangels.com',
  client_id: 'YIqXlDY0bFWWwzmeagLKKTTpApYFzWvA',
  custom_domain: 'https://cdn.eu.auth0.com',
  org_id: 'iangels',
  redirectUrl: 'https://app.iangels.com',
  cloudinaryCloudName: 'iangels',
  gtmId: 'GTM-5S4WJG8',
  marketing_website_base_url: 'https://www.iangels.com/',
  auth0_connection: 'UPA-Prod',
  hubspot_portal_id: '25941199',
  hubspot_hublet: 'eu1',
  // ── Staff-only gate (src/auth/staffAccess.js) ──────────────────────────────────────────────────────────────
  // ON at the V2 go-live: whoever signs in to legacy must be staff, or is signed out and sent to V2's login.
  // Staff = any address on exactly @iangels.com, plus the exact addresses below (case-insensitive), plus Gmail
  // "+" aliases of staff_plus_alias_bases only. Adding someone = a PR here.
  // ⛔ Turn on only once https://www.iangels.com/login is V2 (go-live step 4.3 passed). Spec: angels67-api-v2
  // docs/APP_IANGELS_REDIRECT_RUNBOOK.md.
  staff_only_gate: true,
  staff_gate_redirect_url: 'https://www.iangels.com/login',
  // Maayan's list (03-Nov-2026). There is no domain rule for any domain except @iangels.com.
  staff_allow_list: [
    'liat@iangels.co', // a .co address: this one address only, not the iangels.co domain
    'maayansasson@gmail.com',
    'htamar17@gmail.com', // Tamar's private Gmail
    'asher.matalon@i-cloudius.com', // iCloudius (no i-cloudius.com domain rule)
    'liron.zohar@i-cloudius.com', // iCloudius
  ],
  // Gmail "+" aliases pass for these base addresses ONLY (test accounts maayansasson+N@gmail.com, htamar17+N@gmail.com).
  staff_plus_alias_bases: ['maayansasson@gmail.com', 'htamar17@gmail.com'],
};
